<app-loader *ngIf="loading"></app-loader>
<ng-template appShowpopup></ng-template>
<div class="h-screen flex bg-white overflow-hidden">
  <div class="lg:w-1/2 w-full my-auto">
    <div class="text-center">
      <img class="mx-auto" [src]="Images.FRACTAL_LOGO" alt="" />
      <h2
        class="xs:text-xl md:text-2xl font-semibold mt-5 text-primary_Text_Color"
      >
        Welcome to iqigai
      </h2>
      <p
        class="xs:!text-sm md:!text-base font-medium text-secondary_Light_Text_Color mt-2 mb-6"
      >
        {{
          addPasswordForm
            ? "Set your password."
            : signUpVisible || emailOtpRequired || phoneOtpRequired
            ? "Verify OTP."
            : "Sign In Now."
        }}
      </p>

      <ng-container *ngIf="emailOtpRequired || phoneOtpRequired">
        <div
          class="xs:w-[90%] md:w-1/2 2xl:w-5/12 w-3/5 lg:w-[78%] xl:w-3/5 mx-auto mt-5"
        >
          <!-- EMAIL OTP -->
          <div
            *ngIf="emailOtpRequired"
            class="bg-body_Bg_Color xs:p-2 sm:p-3 rounded-xl mb-4"
          >
            <div class="flex items-start">
              <img
                [src]="Images.INFO_CIRCLE"
                width="15"
                class="sm:mt-[2px] mr-2"
              />
              <span
                class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs font-medium"
              >
                <ng-container *ngIf="isSignUpStaticOtpEmail">
                  Unable to reach your email. Please enter the OTP
                  <span class="font-semibold text-primary_Text_Color">
                    {{ staticSignUpOtpValue }}
                  </span>
                </ng-container>
                <ng-container *ngIf="!isSignUpStaticOtpEmail">
                  Email OTP sent to {{ email }}
                </ng-container>
              </span>
            </div>

            <div class="mt-3">
              <div class="flex items-center">
                <span
                  class="text-secondary_Light_Text_Color xs:text-xs sm:text-sm font-medium"
                >
                  Enter Email OTP
                </span>

                <!-- TIMER -->
                <span *ngIf="emailTimeLeft > 0" class="ml-auto flex mr-2">
                  <img [src]="Images.CLOCK_ICON" width="14" />
                  <span class="ml-1 text-sm text-blue_Color font-semibold">
                    00:<span *ngIf="emailTimeLeft < 10">0</span
                    >{{ emailTimeLeft }}
                  </span>
                </span>

                <!-- RESEND -->
                <span
                  *ngIf="emailTimeLeft <= 0"
                  (click)="resendEmailOtp()"
                  class="ml-auto cursor-pointer xs:text-xs sm:text-sm text-blue_Color font-semibold underline"
                >
                  Resend OTP
                </span>
              </div>

              <div
                class="border pb-4 rounded-lg mt-2 w-full"
                [ngClass]="
                  emailVerified ? 'border-green-500' : 'border-card_Bg_Color'
                "
              >
                <ng-otp-input
                  [config]="config"
                  class="mt-10"
                  (onInputChange)="onEmailOtpChange($event)"
                ></ng-otp-input>
              </div>

              <p
                *ngIf="emailVerified"
                class="text-green-500 xs:text-xxs sm:text-xs mt-2 font-medium"
              >
                Email verified
              </p>
            </div>
          </div>

          <!-- PHONE OTP -->
          <div
            *ngIf="phoneOtpRequired"
            class="bg-body_Bg_Color xs:p-2 sm:p-3 rounded-xl mb-4"
          >
            <div class="flex items-start">
              <img
                [src]="Images.INFO_CIRCLE"
                width="15"
                class="mt-[2px] mr-2"
              />
              <span
                class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs font-medium"
              >
                <!-- STATIC OTP -->
                <ng-container *ngIf="isSignUpStaticOtp">
                  Unable to reach your mobile number. Please enter the OTP
                  <span class="font-semibold text-primary_Text_Color">
                    {{ staticSignUpOtpValue }}
                  </span>
                </ng-container>

                <!-- Mobile NOT reachable, OTP sent to email -->
                <ng-container
                  *ngIf="!isSignUpStaticOtp && isPhoneOtpOnMailSignup"
                >
                  Mobile number not reachable. OTP has been sent to
                  <span class="font-semibold">{{ email }}</span>
                </ng-container>

                <!-- Normal mobile OTP -->
                <ng-container
                  *ngIf="!isSignUpStaticOtp && !isPhoneOtpOnMailSignup"
                >
                  Mobile OTP sent to +91 {{ mobile }}
                </ng-container>
              </span>
            </div>

            <div class="mt-3">
              <div class="flex items-center">
                <span
                  class="text-secondary_Light_Text_Color xs:text-xs sm:text-sm font-medium"
                >
                  Enter Mobile OTP
                </span>

                <!-- TIMER -->
                <span *ngIf="phoneTimeLeft > 0" class="ml-auto flex mr-2">
                  <img [src]="Images.CLOCK_ICON" width="14" />
                  <span class="ml-1 text-sm text-blue_Color font-semibold">
                    00:<span *ngIf="phoneTimeLeft < 10">0</span
                    >{{ phoneTimeLeft }}
                  </span>
                </span>

                <!-- RESEND -->
                <span
                  *ngIf="phoneTimeLeft <= 0"
                  (click)="resendPhoneOtp()"
                  class="ml-auto cursor-pointer xs:text-xs sm:text-sm text-blue_Color font-semibold underline"
                >
                  Resend OTP
                </span>
              </div>

              <div
                class="border pb-4 rounded-lg mt-2 w-full"
                [ngClass]="
                  phoneVerified ? 'border-green-500' : 'border-card_Bg_Color'
                "
              >
                <ng-otp-input
                  [config]="config"
                  class="mt-10"
                  (onInputChange)="onPhoneOtpChange($event)"
                ></ng-otp-input>
              </div>

              <p
                *ngIf="phoneVerified"
                class="text-green-500 sm:text-xs mt-2 font-medium"
              >
                Mobile verified
              </p>
            </div>
          </div>

          <!-- FINAL BUTTON -->
          <button
            (click)="completeSignUp()"
            class="bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color w-full xs:text-xs sm:text-base font-semibold text-center py-3 rounded-lg cursor-pointer"
            [disabled]="!allOtpEntered()"
          >
            Verify Otp
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="addPasswordForm">
        <form
          [formGroup]="setPasswordForm"
          class="overflow-y-auto loginformCss changeScrollbarStyle"
        >
          <div
            class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto"
          >
            <div class="relative mb-3">
              <input
                id="fpPassword"
                name="password"
                [type]="showPasswordForgotPassword ? 'text' : 'password'"
                formControlName="password"
                class="text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[65px] text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Password</label
              >
              <div
                *ngIf="
                  setPasswordForm.get('password').touched &&
                  setPasswordForm.get('password').errors
                "
                class="text-red-600 text-start my-[5px] xs:text-[8px] sm:text-xs"
              >
                <div
                  *ngIf="
                    setPasswordForm.get('password').errors.minLength;
                    text-xs
                  "
                >
                  Minimum 8 characters required
                </div>
                <div
                  *ngIf="
                    setPasswordForm.get('password').errors.uppercase ||
                    setPasswordForm.get('password').errors.lowercase
                  "
                >
                  Must include at least one uppercase & one lowercase letter
                </div>
                <div
                  *ngIf="
                    setPasswordForm.get('password').errors.number ||
                    setPasswordForm.get('password').errors.special
                  "
                >
                  Must include at least one number & one special character
                </div>
              </div>
              <button
                type="button"
                (click)="togglePasswordForgotPassword()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPasswordForgotPassword
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>

            <div class="relative mb-3">
              <input
                id="suConfirmPassword"
                name="confirmPassword"
                [type]="showPasswordForgotPasswordConfirm ? 'text' : 'password'"
                formControlName="confirmPassword"
                class="text-gray-dark border border-card_Bg_Color mx-auto peer block w-full appearance-none rounded-lg px-0 py-[14px] pl-3 h-[65px] text-base font-bold text-primary_Text_Color focus:border-card_Border_Color focus:outline-none focus:ring-0 focus:pt-[28px] pt-[28px]"
                placeholder=""
                required
              />
              <label
                for="suConfirmPassword"
                class="absolute top-[22px] left-[15px] font-medium text-sm text-secondary_Light_Text_Color duration-300 transform -translate-y-[15px] transparent peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[15px] peer-focus:left-[15px] peer-focus:text-xs"
                >Confirm Password</label
              >
              <div
                *ngIf="
                  setPasswordForm.get('confirmPassword').hasError('required') &&
                  setPasswordForm.get('confirmPassword').touched
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Confirm password is required
              </div>
              <div
                *ngIf="
                  setPasswordForm.touched &&
                  setPasswordForm.get('password').value !==
                    setPasswordForm.get('confirmPassword').value
                "
                class="text-red-600 text-end my-[5px] relative right-0 xs:text-[8px] sm:text-xs"
              >
                Passwords do not match
              </div>
              <button
                type="button"
                (click)="togglePasswordForgotPasswordConfirm()"
                class="absolute top-[20px] right-[20px]"
              >
                <img
                  [src]="
                    showPasswordForgotPasswordConfirm
                      ? service.Images.OPEN_EYE
                      : service.Images.CLOSE_EYE
                  "
                  alt=""
                />
              </button>
            </div>
          </div>

          <!-- terms and condition -->
          <div   class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto">
            <!-- <div
              class="flex items-start md:my-5 xs:my-2"
              (click)="checkBoxTermsAndConditions($event)"
            >
              <input
                type="checkbox"
                class="!w-4 !h-4 customCheckBox flex-shrink-0 mt-0.5"
                id="myCheckbox"
                formControlName="termsAccepted"
                name="termsAndConditionsChecked"
                required
              />

              <p
                class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs my-auto text-start ml-3"
              >
                I consent to processing of my personal information
                <span
                  class="ml-1 cursor-pointer relative group"
                  aria-label="More info"
                >
                  <img
                    [src]="service.Images.INFO_CIRCLE"
                    width="12"
                    alt="Info"
                    class="inline-block"
                  />

                  <span
                    class="absolute consentPopup top-full mt-2  bg-gray-900 text-white xs:text-xxs md:text-xs font-normal p-3 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-[99999]"
                  >
                    I consent to the processing, collection, and sharing of my
                    personal information (PII), including name, contact
                    information, work experience, and educational
                    qualifications, for potential recruitment purposes.
                  </span>
                </span>
              </p>
            </div> -->

            <div
              class="flex items-start md:my-5 xs:my-2"
              (click)="checkBoxPrivacyPolicy($event)"
            >
              <input
                type="checkbox"
                class="!w-4 !h-4 customCheckBox flex-shrink-0 !m-0 mt-0.5"
                id="myCheckbox"
                formControlName="privacyAccepted"
                name="privacyPolicyChecked"
                required
              />
              <p
                  class="text-secondary_Light_Text_Color xs:text-xxs sm:text-xs !leading-5 font-normal my-auto text-start ml-3"
                >
                   I consent to the processing of my personal data for creating my account on the platform, participating in recruitment processes and assessments, and receiving communications regarding my candidature via phone/email in accordance with the 
                  <span
                    (click)="openTermsAndConditionModal('Privacy Policy','https://iqigai.ai/privacy-policy')"
                    class="text-blue_Color underline cursor-pointer"
                  >
                    Privacy policy
                  </span>
                   and 
                   <span
                    (click)="openTermsAndConditionModal('Terms and Conditions','https://iqigai.ai/terms-and-conditions')"
                    class="text-blue_Color underline cursor-pointer"
                  >
                    Terms and Conditions
                  </span>
                </p>
            </div>
          </div>
          <div
            class="xs:w-5/6 md:w-1/2 2xl:w-5/12 w-3/5 lg:w-3/4 xl:w-3/5 mx-auto"
          >
            <div class="mx-auto mt-10">
              <!-- <span class="flex">
                <span
                  class="text-secondary_Light_Text_Color xs:text-xs md:text-sm font-medium"
                  >Enter OTP</span
                >
                <span *ngIf="timeLeft > 0" class="ml-auto flex mr-2">
                  <img [src]="Images.CLOCK_ICON" width="15" alt="" />
                  <span class="ml-1 text-sm text-blue_Color font-semibold"
                    >00:<span *ngIf="timeLeft < 10">0</span>{{ timeLeft }}</span
                  >
                </span>
                <span *ngIf="timeLeft <= 0" class="ml-auto cursor-pointer">
                  <p
                    (click)="resendOtpForForgotPassword()"
                    class="xs:text-xs md:text-sm text-blue_Color font-semibold underline"
                  >
                    Resend OTP
                  </p>
                </span>
              </span> -->
              <!-- <div
                [ngClass]="
                  enableVerifyAndContinue
                    ? 'border-Active_Otp_Border'
                    : 'border-card_Bg_Color'
                "
                class="border xs:pb-[1.6rem] sm:pb-4 rounded-lg mt-2 w-full"
              >
                <ng-otp-input
                  #otpInput
                  (onInputChange)="onChangePasscodeForForgotPassword($event)"
                  class="mt-10"
                  [config]="config"
                >
                </ng-otp-input>
              </div> -->
              <!-- <div class="flex justify-end mt-2">
              <span
                class="text-xs ml-3 cursor-pointer text-blue_Color font-medium"
                (click)="enableEmailform()"
                >Having trouble? Sign in with Email</span
              >
            </div> -->
              <app-button
                (buttonClick)="resetPassword(setPasswordForm.value)"
                [disabled]="!(setPasswordForm.valid && termsAndConditionsChecked && privacyPolicyChecked )"
                [ngClass]="
                  setPasswordForm.valid && termsAndConditionsChecked && privacyPolicyChecked 
                    ? 'continue_btn-enabled'
                    : 'continue_btn-disabled'
                "
                [class]="
                  'xs:text-xs md:text-base py-3 w-full rounded-lg mt-5 font-semibold'
                "
                [innerText]="'Continue'"
              >
              </app-button>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
  <div class="bg-custom-gradient w-1/2 h-full hidden lg:block">
    <div class="carousel-inner relative overflow-hidden w-full mt-24">
      <!--Slide 1-->
      <input
        class="carousel-open"
        type="radio"
        id="carousel-1"
        name="carousel"
        aria-hidden="true"
        hidden=""
        checked="checked"
      />
      <div class="carousel-item absolute opacity-0">
        <div class="block h-full w-full text-white text-5xl text-center">
          <img class="mx-auto" [src]="Images.BANNER_CLOUD" alt="" />
          <img
            class="mx-auto"
            [src]="theme ? Images.SIGNIN_BANNER_BLUE : Images.SIGNIN_BANNER"
            alt=""
          />
        </div>
      </div>

      <!--Slide 2-->
      <input
        class="carousel-open"
        type="radio"
        id="carousel-2"
        name="carousel"
        aria-hidden="true"
        hidden=""
      />
      <div class="carousel-item absolute opacity-0">
        <div
          class="block h-full w-full text-white text-5xl text-center z-50 hhg"
        >
          <img class="mx-auto" [src]="Images.BANNER_CLOUD" alt="" />
          <img
            class="mx-auto"
            [src]="theme ? Images.SIGNIN_BANNER_BLUE : Images.SIGNIN_BANNER"
            alt=""
          />
        </div>
      </div>

      <!--Slide 3-->
      <input
        class="carousel-open"
        type="radio"
        id="carousel-3"
        name="carousel"
        aria-hidden="true"
        hidden=""
      />
      <div class="carousel-item absolute opacity-0">
        <div class="block h-full w-full text-white text-5xl text-center">
          <img class="mx-auto" [src]="Images.BANNER_CLOUD" alt="" />
          <img
            class="mx-auto"
            [src]="theme ? Images.SIGNIN_BANNER_BLUE : Images.SIGNIN_BANNER"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- Add additional indicators for each slide-->
    <ol class="carousel-indicators mt-20" (click)="carouselActive($event)">
      <li class="inline-block mr-2">
        <label
          for="carousel-1"
          class="carousel-bullet active cursor-pointer block text-4xl text-secondary_Light_Text_Color"
          >•</label
        >
      </li>
      <li class="inline-block mr-2">
        <label
          for="carousel-2"
          class="carousel-bullet cursor-pointer block text-4xl text-secondary_Light_Text_Color"
          >•</label
        >
      </li>
      <li class="inline-block mr-2">
        <label
          for="carousel-3"
          class="carousel-bullet cursor-pointer block text-4xl text-secondary_Light_Text_Color"
          >•</label
        >
      </li>
    </ol>
  </div>
</div>

<app-terms-condition-modal></app-terms-condition-modal>
